<template>
<div class="page">
    <Header title="沙龙详情" />
    <div class="header">
        <img class="cover-img" :src="dataSources.cover_img" />
        <div class="body">
            <div class="title">
                <p>{{ dataSources.name }}</p>
                <span>免费</span>
            </div>
            <div class="time-tips">{{ time_text }}</div>
            <div>
                <img :src="Images.icon_time" alt="" />
                <p>开放时间：</p>
            </div>
            <p class="text">
                {{ dataSources.start_time }}
            </p>
            <div>
                <img :src="Images.icon_time" alt="" />
                <p>报名截止时间：</p>
            </div>
            <p class="text">
                {{ dataSources.expire_time_text }}
            </p>
            <div>
                <img :src="Images.icon_address" alt="" />
                <p>上课地点：</p>
                <div @click="showLocation" :data-lat="dataSources.lat" :data-lng="dataSources.lng" :data-title="dataSources.address" :data-desc="dataSources.area">
                    <img :src="Images.icon_nav" alt="" />
                    <p>导航</p>
                </div>
            </div>
            <p class="text">{{ dataSources.area }}{{ dataSources.address }}</p>
            <div>
                <img :src="Images.icon_people" alt="" />
                <p>
                    已报名：<span>{{ dataSources.num_text }}人</span>
                </p>
            </div>
        </div>
    </div>
    <div class="title1">
        <img :src="Images.icon_home_list_logo4" alt="" />
        <p>传承师信息</p>
    </div>
    <div class="item">
        <img :src="dataSources.inheritor_cover" />
        <div>
            <p>
                <span>{{ dataSources.inheritor_name }}</span>
                <span>{{ dataSources.master_mobile }}</span>
            </p>
            <span>{{ dataSources.inheritor_introduce }}</span>
        </div>
    </div>
    <div class="title2">活动详情</div>
    <div class="detail">
        <div class="text-j">{{ dataSources.salon_desc }}</div>
        <img :src="dataSources.detail_img" />
    </div>
    <div class="tell none">
        <img :src="Images.icon_salon_inheritor" alt="" />
        <p v-if="service && service.customer_service">
            咨询顾问：{{ service.customer_service.name }}
            {{ service.customer_service.mobile }}
        </p>
    </div>
    <div class="footerBox" v-if="user_type == Constants.USER_STUDENT">
        <template v-if="status == 1">
            <div class="btn" v-if="dataSources.is_sign_up == 0" @click="confirmSubmit">立即报名</div>
            <div class="btn-over" v-else>已报名</div>
        </template>
        <template v-if="status == 2">
            <div class="btn-over" v-if="dataSources.is_sign_up == 1">已报名</div>
            <div class="btn-over" v-else>报名已截止</div>
        </template>
    </div>
    <div class="footerBox flex rcb" v-if="user_type == 'agent'">
        <div v-if="dataSources.is_pass == 0" class="btn" @click="releaseSubmit">立即发布</div>
        <div v-if="dataSources.is_pass != 0" class="btn" @click="_onPressToNavigate('', 'salonParticipant', {id, user_type})">报名列表</div>
        <div v-if="dataSources.is_pass > 1 && dataSources.is_enroll != 3" class="btn cur" @click="onSubmitEndSalon">结束沙龙</div>
    </div>
    <div class="footerBlank"></div>
</div>
</template>

<script>
import {
    mapGetters
} from "vuex";
import {wxSetup, wxShare} from '@/utils/wxShare'
import Header from "../../components/Header";
export default {
    components: {
        Header: Header,
    },
    computed: {
        ...mapGetters(["userInfo", "service"]),
    },
    data() {
        return {
            user_type: "",
            id: "",
            dataSources: {},
            countDownNum: 0,
            time_text: "加载中...",
            status: 0,
        };
    },
    async created() {
        this.id = this.$route.query.id;
        this.user_type = this.$route.query.user_type || "";
        await this.requestData();
    },
    mounted() {
        setTimeout(() => {
            this._setupWechatConfig();
        }, 500);
    },
    methods: {

        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if (pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({
                path,
                query
            });
        },

        // 设置分享参数
        async _setupWechatConfig() {
            let url = this.API.wx_setup_info;
            let data = {
                page_flag: 'common',
                share_url: window.location.href.split('#')[0],
            };

            let _urlTemp = window.location.href;
            _urlTemp = _urlTemp.replace('user_type=agent', 'user_type=student');
            _urlTemp = _urlTemp.replace('user_type=master', 'user_type=student');
            if (_urlTemp.indexOf('is_share=1&uid=') > -1) {
                _urlTemp = _urlTemp.split('is_share=1&uid=')[0] + 'is_share=1&uid=' + this.userInfo.id;
            } else {
                _urlTemp = _urlTemp + '&is_share=1&uid=' + this.userInfo.id;
            }

            console.log('this.userInfo, _urlTemp---->', this.userInfo, _urlTemp);

            // 非微信环境直接退出
            if (!this.$isWeiXin()) return;
            let result = await this.$post(url, data);
            if (result.code == this.GLOBAL.SUCCESS_CODE) {
                let share_params = {
                    ...result.data.share_params,
                    title: this.dataSources.name,
                    desc: this.dataSources.salon_desc,
                    icon: this.dataSources.cover_img,
                    link: _urlTemp,
                }
                wxShare(result.data.share_config, share_params, () => {});
            }
        },

        // 请求首页数据
        async requestData() {
            let url = this.API.salon_detail;
            let params = {
                id: this.id,
                token: this.Lockr.get('token') || ''
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.dataSources = result.data;
                this.forematTimeout()
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
        // 查看位置
        showLocation(e) {
            let {
                lat,
                lng,
                title,
                desc
            } = e.currentTarget.dataset
            let url = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${title}&content=${desc}&output=html`
            window.location.href = url
        },
        // 倒计时
        forematTimeout() {
            let expire_time = this.dataSources.expire_time * 1
            let now_time = Math.round(new Date().getTime() / 1000)
            let d_time = expire_time - now_time
            if (d_time > 0) {
                this.status = 1
                this.countDownNum = expire_time - now_time
                this.loopTimeout()
            } else {
                this.status = 2
                this.time_text = '报名已截止'
            }
        },
        // 倒计时循环
        loopTimeout() {
            this.timer && clearInterval(this.timer);
            this.timer = setInterval(() => {
                this.time_text = this.countDown(this.countDownNum -= 1)
            }, 1000);
        },
        // 结速倒计时
        clearTimeoutFn() {
            this.timer && clearInterval(this.timer);
        },
        // 时间戳转倒计时
        countDown(time) {
            var d = parseInt(time / 60 / 60 / 24);
            d = d < 10 ? "0" + d : d;
            var h = parseInt((time / 60 / 60) % 24);
            h = h < 10 ? "0" + h : h;
            var m = parseInt((time / 60) % 60);
            m = m < 10 ? "0" + m : m;
            var s = parseInt(time % 60);
            s = s < 10 ? "0" + s : s;
            return '报名截止时间剩余：' + d + "天" + h + "时" + m + "分" + s + "秒";
        },
        confirmSubmit() {
            if(!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            this.Message({
                type: 2,
                title: "温馨提示",
                content: "你确定要报名当前沙龙？",
                btn: ['取消', '确定'],
                onClose: (res) => {
                    console.log(res)
                    if (res == 1) {
                        this.enrollSubmit()
                    }
                }
            })
        },
        async enrollSubmit() {
            let url = this.API.salon_enroll;
            let params = {
                salon_id: this.id,
                token: this.Lockr.get('token')
            };
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    type: 5,
                    title: "温馨提示",
                    content: "恭喜您报名成功",
                    onClose: () => {
                        this.requestData()
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        async releaseSubmit() {
            let url = this.API.release_salon;
            let params = {
                id: this.id,
                token: this.Lockr.get('token')
            };
            if(!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.Message({
                    type: 5,
                    title: "温馨提示",
                    content: "发布沙龙成功",
                    onClose: () => {
                        this.requestData()
                    }
                });
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },

        async onSubmitEndSalon() {

            this.Message({
                type: 2,
                title: "温馨提示",
                content: "你确定要结束当前沙龙？",
                btn: ['取消', '确定'],
                onClose: (res) => {
                    console.log(res)
                    if (res == 1) {
                        this._doSubmitEndSalon()
                    }
                }
            })
        },

        async _doSubmitEndSalon() {
            let url = this.API.stop_salon;
            let params = {
                id: this.id,
                token: this.Lockr.get('token')
            };
            if(!this.userInfo.mobile) {
                return this.$emit(this.Constants.SHOWBINDMOBILEPOPUP, true);
            }
            let result = await this.$post(url, params);
            this.Message({
                title: result.msg,
            });
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                this.requestData();
            }
        }
    }
};
</script>

<style lang="less" scoped>
.page {
    padding: 1rem 1rem;
}

.header {
    .cover-img {
        width: 100%;
        margin-bottom: 1rem;
    }

    >.body {
        padding: 1rem 1rem;
        background: #fff;
        border-radius: .5rem;

        >.title {
            display: flex;
            align-items: center;

            p {
                flex: 1;
                font-size: 15px;
                color: #333;
            }

            span {
                font-size: 18px;
                color: #f83535;
            }
        }

        >.time-tips {
            height: 40px;
            margin: 1rem 0;
            padding: 0 1rem;
            background-image: url('../../assets/img/img_salon_article.png');
            background-size: cover;
            font-size: 14px;
            color: #7181eb;
            line-height: 32px;
            font-weight: 500;
            display: flex;
            align-items: center;
            justify-content: center;
            letter-spacing: 1px;
        }

        >div {
            display: flex;
            margin-top: 5px;
            align-items: center;

            >img {
                width: 15px;
                height: 15px;
                object-fit: contain;
                margin-right: 5px;
            }

            >p {
                flex: 1;
                font-size: 14px;
                color: #333;
                font-weight: 500;

                >span {
                    font-size: 13px;
                    font-weight: 400;
                }
            }

            >div {
                display: flex;
                align-items: center;

                >img {
                    width: 20px;
                    height: 20px;
                    margin-right: 5px;
                }

                >p {
                    font-size: 14px;
                    color: #7181eb;
                }
            }
        }

        >.text {
            margin-top: 5px;
            font-size: 13px;
            color: #333;
        }
    }
}

.title1 {
    margin-top: 15px;
    display: flex;
    align-items: center;

    img {
        width: 22px;
        height: 22px;
        margin-right: 5px;
    }

    p {
        font-size: 15px;
        color: #333333;
        font-weight: 500;
    }
}

.item {
    position: relative;
    margin-top: 30px;
    height: 74px;
    background: #ffffff;
    border-radius: 0.5rem;

    >img {
        position: absolute;
        left: 1rem;
        bottom: 1rem;
        width: 79px;
        height: 76px;
        object-fit: cover;
        margin-right: 1rem;
    }

    >div {
        margin-left: 89px;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        >p {
            font-size: 14px;
            color: #333;
            font-weight: 500;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            span {
                margin-right: 1rem;
                font-size: 14px;
                color: #7181eb;
            }
        }

        >span {
            font-size: 13px;
            color: #333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }
}

.title2 {
    margin-top: 1rem;
    font-size: 15px;
    color: #333333;
    font-weight: 500;
}

.detail {
    color: #666;
    line-height: 1.5;
    margin-top: 1rem;
    font-size: 1.4rem;
    padding: 1rem 1rem;
    background: #fff;
    border-radius: .5rem;

    img {
        max-width: 100%;
    }
}

.tell {
    margin-top: 1rem;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url('../../assets/img/img_btn_bg1.png');
    background-size: cover;

    img {
        width: 13px;
        height: 17px;
        margin-right: 7px;
    }

    p {
        font-size: 13px;
        color: #fff;
    }
}

.footerBlank {
    height: 70px;
}

.footerBox {
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    z-index: 10;
    height: 40px;
    padding: 1rem;
    background-color: #fff;
    box-shadow: 0 0 1rem rgba(0, 0, 0, 0.2);

    .btn {
        flex: 1;
        color: #fff;
        margin: 0 10px;
        font-size: 15px;
        font-weight: 500;
        line-height: 40px;
        text-align: center;
        border-radius: 0.5rem;
        background: linear-gradient(225deg, #9cb2f4, #6472e8);
        &.cur {
            background: linear-gradient(225deg, #d8d8d8, #8ecafb);
        }
    }

    .btn-over {
        background: #d6d6d6;
        border-radius: 0.5rem;
        line-height: 40px;
        text-align: center;
        font-size: 15px;
        color: #666;
        font-weight: 500;
    }
}
</style>
